export default "__VITE_ASSET__B_7To2VE__"